 $(function () {
      $('#checkout').prop('disabled', true);
        $('#consentCheckbox').click(function () {
            if ($(this).prop('checked')) {
                $('#checkout').prop('disabled', false);
            } else {
                $('#checkout').prop('disabled', true);
            }
        });
 });